import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  separator: {
    margin: '0 4px'
  },

  crumb: {
    cursor: 'pointer'
  },

  currentCrumb: {
    cursor: 'default'
  }
}))

export default useStyles
